module.exports = __webpack_public_path__ + "static/media/AssociationLogo.e1b00797.svg";